<template>
  <div class="li">
    <i class="myIcon iconfont" :class="icon"></i>
    {{ name }}
    <i class="delete iconfont icon-close" title="删除" @click="deleteNode(li)"></i>
  </div>
</template>

<script>
export default {
  name: "resultLi",
  props: {
    li: {
      type: Object,
      default() {
        return {};
      },
    },
    index: {
      type: Number,
    },
  },
  inject: {
    $seletPermissions: {
      default: null,
    },
  },
  computed: {
    icon() {
      if (this.li.isRole) {
        return "icon-zhuhutiaocha";
      } else if (this.li.valueType === "dept") {
        return "icon-icon_user_bm";
      } else {
        return "icon-icon-user";
      }
    },
    name() {
      let li = this.li;
      if (li.isDefaultSelect) {
        return li.name;
      }
      if (li.isRole) {
        let str = li.org.config_includeChild ? "（包含下级）" : "";
        return li.org.name + str + "-" + li.role._name;
      } else {
        return li.name + (li.config_includeChild ? "（包含下级）" : "");
      }
    },
  },
  methods: {
    deleteNode(li) {
      li.config_includeChild = false;
      li.config_checked = false;
      if (this.$seletPermissions.resultLists[this.index].id == li.id) {
        let defIndex = _.map(
          this.$seletPermissions.defaultSelectValue,
          (item) => {
            return item.id;
          }
        ).indexOf(li.id);
        if(defIndex>-1){
          this.$seletPermissions.defaultSelectValue.splice(defIndex, 1);
        }
        this.$seletPermissions.resultLists.splice(this.index, 1);
      }
    },
  },
};
</script>

<style>

</style>
